import { BellOutlined as BellIcon, CalendarOutlined } from '@ant-design/icons';
import { NotificationProps } from './type';
import { Badge } from 'antd';

const tableColumns = {
  displayColumns: [
    {
      title: 'Tiêu đề',
      key: 'title',
      render: (text: string, record: NotificationProps, index: number) => {
        return (
          <div
            style={{
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            <BellIcon style={{ color: record.color }} className='tw-mr-2' />
            {text}
          </div>
        );
      },
      sort: false,
    },
    {
      title: 'Trạng thái',
      key: 'statusText',
      style: {
        fontWeight: '400',
      },
      width: '100px',
      render: (text: string, record: NotificationProps, index: number) => {
        return (
          record.status 
          ? text 
          : <Badge dot><b>{text}</b></Badge>
        );
      },
    },
    {
      title: 'Thời gian',
      key: 'createDate',
      prefix: <CalendarOutlined className='tw-mr-2' />,
      render: 'renderDateTime',
      style: {
        fontWeight: '400',
      },
      width: '1%',
    },
  ],
  rowKey: 'thongBaoId',
};

const validateQuillContent = (_:any, value:any, callback:any) => {
  if (value === '<p></p>' || value === '<p><br></p>' || !value) {
    callback("Chưa nhập nội dung thông báo");
  } else {
    callback();
  }
};
export {
  tableColumns,
  validateQuillContent
}
